module.exports = __webpack_public_path__ + "static/media/SXP-BNB.7fef01aa.svg";